import styled from 'styled-components';
import { navBarHeight, Format, StyleColor, blurredBackgroundColor, BaseStyledComponentProps } from '../../utils/styles-constants';
import { PageType } from '../../containers/Page/constants';

interface StyledPageProps {
	pageType: PageType;
	isScrollable?: boolean;
}

const PageWrapper = styled('div')`
	background: ${(props: BaseStyledComponentProps) => props.theme.primary.backgroundColor};
	position: absolute;
	top: ${navBarHeight};
	left: 0;
	right: 0;
	bottom: 0;

	${(props: StyledPageProps) => props.isScrollable &&
		`-webkit-overflow-scrolling: touch;
		overflow-y: auto;
		overflow-x: hidden;`
	}

	${(props: StyledPageProps) =>
		[
			PageType.NotFoundPage,
			PageType.ParametersPage,
			PageType.ProfilePage,
			PageType.ProposalStatsPage,
		].includes(props.pageType) &&
		`padding: 50px;

		@media ${Format.Smartphone} {
			padding: 10px 25px;
		}`
	}

	${(props: StyledPageProps) => props.pageType === PageType.StaticPage &&
		`padding: 0;`
	}

	${(props: StyledPageProps) => props.pageType === PageType.ProposalStatsPage && `
		display: flex;
		flex-direction: column;
		overflow-y: hidden;
		padding-bottom: 0;

		@media ${Format.Smartphone} {
			padding-bottom: 0;
		}
	`}
`;

const TitleWrapper = styled('div')`
	padding-top: 20px;
	padding-bottom: 15px;

	@media ${Format.Smartphone}, ${Format.SmartphoneLandscape} {
		padding-top: 15px;
	}
`;

const BottomBarHeight = '50px';
const bottomBarColor = StyleColor.Grey700;

const StyledBottomBar = styled('div')`
	backdrop-filter: blur(10px);
	height: ${BottomBarHeight};
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
`;

const BottomBarBackground = styled('div')`
	height: 100%;
	background-color: ${blurredBackgroundColor};
	display: flex;
	align-items: center;
	justify-content: space-around;
`;

export { PageWrapper, TitleWrapper, StyledPageProps, StyledBottomBar, BottomBarBackground, BottomBarHeight, bottomBarColor };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Page/styles.ts